import { Table, Alert, Button, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Loading from '../../app/components/Loading';
import getClippedText from '../../app/utils/getClippedText';
import { useListCouponsQuery, useSyncCouponsMutation } from './couponsApi';

const COLUMNS = ['Code', 'Name', 'Description', 'Created at', 'Availability', 'Actions'];

function WhiteListed({ whitelisted }: { whitelisted: boolean }) {
  if (whitelisted) {
    return <span className="text-success">Available</span>;
  }
  return <span className="text-danger">Unavailable</span>;
}

function CouponsList() {
  const { isFetching, data: coupons = [], isError } = useListCouponsQuery();
  const [syncCoupons, { error: syncCouponError, isLoading: isSyncing }] = useSyncCouponsMutation();

  if (isFetching) {
    return <Loading text="Loading coupons list" />;
  }

  const onSyncClicked = () => syncCoupons();

  return (
    <main>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Coupons whitelist</h1>
        <Button variant="warning" onClick={onSyncClicked} disabled={isSyncing}>
          Force sync
        </Button>
      </div>

      {syncCouponError && <Alert variant="danger">An error occured while synchronizing with Chargebee</Alert>}
      {isSyncing && (
        <Alert variant="info" className="d-flex align-items-center gap-4">
          <Spinner /> Synchronizing the coupons with Chargebee, it might take a few seconds.
        </Alert>
      )}
      {isError && <Alert variant="danger">An error occured while fetching the coupons list</Alert>}

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            {COLUMNS.map((column, index) => (
              <th className="col-min" key={index}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {coupons.map((coupon) => (
            <tr key={coupon.id}>
              <td className="col-min">{coupon.chargebeeCouponId}</td>
              <td className="col-min">{getClippedText(coupon.displayName)}</td>
              <td className="col-min">{getClippedText(coupon.description)}</td>
              <td className="col-min">{new Date(coupon.createdAt).toLocaleDateString()}</td>
              <td className="col-min">
                <WhiteListed whitelisted={coupon.whitelisted} />
              </td>
              <td>
                <Link to={`/coupons/${coupon.id}`}>Edit</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </main>
  );
}

export default CouponsList;
